import { products, projects } from '../mock';
import { projectGalleries } from '../galleries';

export const getProjectGallery = (project) => {
  const images = projectGalleries[project.slug];
  return images?.length ? images : [project.image];
};

export const getProductGallery = (product) => {
  const relatedImages = (product.relatedProjects || []).flatMap(
    (slug) => (projectGalleries[slug] || []).slice(0, 4)
  );
  return [...new Set([product.image, ...relatedImages])].filter(Boolean);
};

export const getRelatedProjects = (product) => (product.relatedProjects || [])
  .map((slug) => projects.find((project) => project.slug === slug))
  .filter(Boolean);

const catalogs = {
  project: { items: projects, basePath: '/projeler', gallery: getProjectGallery },
  product: { items: products, basePath: '/urunler', gallery: getProductGallery },
};

export const getPortfolioDetail = (kind, slug) => {
  const { items, basePath, gallery } = catalogs[kind];
  const index = items.findIndex((item) => item.slug === slug);
  const item = items[index];
  if (!item) return { item: null, basePath, images: [] };
  return {
    item, basePath, images: gallery(item),
    previous: items[(index - 1 + items.length) % items.length],
    next: items[(index + 1) % items.length],
  };
};

export const sampleProjects = (items, count) => {
  const shuffled = [...items];
  for (let index = shuffled.length - 1; index > 0; index -= 1) {
    const target = Math.floor(Math.random() * (index + 1));
    [shuffled[index], shuffled[target]] = [shuffled[target], shuffled[index]];
  }
  return shuffled.slice(0, count);
};